module.exports = __webpack_public_path__ + "static/backhand_right_emoji-b1a45d2edb5617c4ca7d9184f6c78ff2.svg";